import LegalPageLayout from "../../layout/LegalPageLayout";

function PrivacyStatementPage() {
  return (
    <LegalPageLayout title="Izjava o zaštiti i prikupljanju osobnih podataka">
      <p>
        Obavezujemo se pružati zaštitu osobnim podacima kupaca, na način da
        prikupljamo samo nužne, osnovne podatke o kupcima / korisnicima koji su
        nužni za ispunjenje naših obveza; informiramo kupce o načinu korištenja
        prikupljenih podataka, redovito dajemo kupcima mogućnost izbora o
        upotrebi njihovih podataka, uključujući mogućnost odluke žele li ili ne
        da se njihovo ime ukloni s lista koje se koriste za marketinške
        kampanje.
      </p>

      <p>
        Svi se podaci o korisnicima strogo čuvaju i dostupni su samo
        djelatnicima kojima su ti podaci nužni za obavljanje posla. Svi naši
        djelatnici i poslovni partneri odgovorni su za poštivanje načela zaštite
        privatnosti.
      </p>
    </LegalPageLayout>
  );
}

export default PrivacyStatementPage;
